<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <ontick-modal
      :open="active"
      :title="'Termos de uso conta Real'"
      size="medium"
      v-on:close="$emit('close')"
      class="overflow-y-auto"
    >
      <div v-show="!success" class="py-6">
        <div class="bg-ontick-carbon-500 rounded px-3 py-3">
          <div
            style="max-height: 280px"
            class="space-y-3 overflow-y-auto text-white"
          >
            <dl class="mb-8 text-center">
              <strong>
                TERMO DE AUTORIZAÇÃO DE ROTEAMENTO EM CONTA REAL NA XP
              </strong>
            </dl>
            <span>Considerando Que:</span>
            <dl>
              (i) A XP Investimentos CCTVM S/A (CNPJ/ME sob o nº
              02.332.886/0001-04) ("XP") autorizou que o software de envio de
              ordens de compra e venda de valores mobiliários denominado OnTick
              Invest ("Software Externo"), desenvolvido pela empresa Delta
              Serviços Financeiros Ltda, inscrita no CNPJ/ME sob o nº
              20.789.071/0001-22 ("Fornecedor"), se conecte com o Order
              Management Service ("OMS") da XP, a fim de que seja possível
              executar ordens na XP por meio da OnTick Invest; e
            </dl>
            <dl>
              (ii) O Cliente autorizou previamente junto à XP o roteamento de
              ordens através da plataforma OnTick Invest.
            </dl>
            <dl>
              1. Eu, Cliente da OnTick Invest, qualificado na Ficha Cadastral
              ("Cliente"), AUTORIZO que a OnTick Invest possa enviar ordens de
              compra e venda através de minha conta na XP.
            </dl>
            <dl>2.- Declaro-me, ainda, ciente:</dl>
            <dl>
              (i) Da complexidade da utilização da OnTick Invest, bem como de
              suas regras e parâmetros de execução;
            </dl>
            <dl>
              (ii) Que a OnTick Invest é um sistema preponderantemente destinado
              a investidores de perfil agressivo com amplo conhecimento do
              mercado;
            </dl>
            <dl>
              (iii) Que devo acompanhar, de forma contínua e ininterrupta, o
              funcionamento da OnTick Invest durante o período em que o estiver
              usando, de forma a tratar e resolver situações de inexecução e/ou
              execução parcial da estratégia;
            </dl>
            <dl>
              (iv) Que pagarei as eventuais multas por ofertas excedentes que
              der causa (multa cobrada pela BM&FBovespa pelo excesso de ordens
              enviadas);
            </dl>
            <dl>
              (v) Que sou responsável pelo meu "log in" e senha, bem como pelo
              manuseio operacional da plataforma, não podendo alegar o
              desconhecimento das funcionalidades para pleitear qualquer
              ressarcimento;
            </dl>
            <dl>
              (vi) Que sou o único e exclusivo responsável pela definição da
              estratégia ou parametrização da OnTick Invest e seu
              acompanhamento;
            </dl>
            <dl>
              (vii) Que sou o único e exclusivo responsável pela seleção,
              escolha ou criação das estratégias a serem executados pela OnTick
              Invest, bem como pela parametrização das mesmas. As perdas
              decorrentes da execução das estratégias através da OnTick Invest
              são de inteira responsabilidade do cliente;
            </dl>
            <dl>
              (viii) Que sou o único e exclusivo responsável pela adequação,
              ajuste e/ou alteração da estratégia, acompanhamento,
              reparametrização durante o dia, ao longo do pregão, se necessário
              ou se assim desejar, não cabendo à OnTick Invest qualquer
              responsabilidade decorrente das eventuais perdas experimentadas em
              decorrência de tais ajustes feitos pelo cliente;
            </dl>
            <dl>
              (ix) Que a OnTick Invest não poderá ser responsabilizada por
              eventuais falhas nos sistemas da B3 ou da XP, como queda de links
              de internet, quedas de energia, casos fortuitos e/ou de força
              maior;
            </dl>
            <dl>
              (x) Que a OnTick Invest não poderá ser responsabilizada por
              quaisquer problemas, falhas ou erros relacionados ao envio de
              ordens para a conta do Cliente na XP que ultrapassem limites,
              margens ou garantias estipuladas ou exigidas pela XP, como por
              exemplo saldo insuficiente, falta de margens de garantia ou
              ausência de ativos em BTC (Banco de Títulos e Custódia) em
              operações que eventualmente exijam aluguel de ativos junto à B3.
            </dl>
            <dl>
              <strong>DOCUMENTO ASSINADO ELETRONICAMENTE</strong>
            </dl>
          </div>
        </div>

        <label class="mt-6 inline-flex items-center rounded">
          <input
            @click="term_of_use = !term_of_use"
            type="checkbox"
            class="form-checkbox text-ontick-blue-500 h-5 w-5 rounded"
            :checked="term_of_use"
          /><span class="ml-2 text-white"
            >Aceite os termos de uso da plataforma</span
          >
        </label>
        <div class="flex justify-center">
          <ontick-button
            @click.native="AcceptTermOfUser()"
            :disabled="!term_of_use"
            :color="term_of_use ? 'secondary' : 'for'"
            class="mt-6 w-3/4 uppercase"
            >Continuar</ontick-button
          >
        </div>
      </div>
      <div v-show="success" class="flex justify-center text-center">
        <dt class="py-12">
          <success-icon
            title="Conta cadastrada com sucesso"
            :active="success"
          />
        </dt>
      </div>
    </ontick-modal>
  </transition>
</template>

<script>
import SuccessIcon from "@/app/shared/components/basic/ontick-success.component.vue";

export default {
  data() {
    return {
      data: {},
      term_of_use: false,
      success: false,
    };
  },
  components: {
    SuccessIcon,
  },
  props: {
    id: { type: String, default: null },
    active: { type: Boolean, default: null },
  },

  methods: {
    AcceptTermOfUser() {
      let params = { history_id: this.id };
      this.$api
        .post(this.$endpoint.ADD_ACCOUNT, params)
        .then(() => {
          this.success = true;
          setTimeout(() => {
            location.reload();
          }, 1500);
        })
        .catch((error) => {
          this.$swal({
            title: error.data.msg,
            icon: "error",
            toast: false,
            position: "center",
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Fechar",

            timerProgressBar: false,
            customClass: {
              popup: "sweetalert_popup",
              title: "sweetalert_title",
              confirmButton: "sweetalert_confirm_button",
              cancelButton: "sweetalert_confirm_button",
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
